
import React from "react";
import { Helmet } from "react-helmet-async";
import { NavBar } from "@/components/navbar";
import {Footer} from "@/components/SiteFooter";
import TitleSection from "@/components/homepage/TitleSection";
import HeroSection from "@/components/homepage/HeroSection";
import FeaturedProcesses from "@/components/homepage/FeaturedProcesses";

const Index = () => {
  return (
    <div className="relative min-h-screen">
      <Helmet>
        <title>Verdea AI | Automate Compliance Workflows</title>
        <meta name="description" content="Automate compliance processes with AI-powered workflows. Reduce time and cost while improving accuracy." />
      </Helmet>
      
      {/* Background Elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-0 right-0 w-96 h-96 blur-3xl opacity-20"
          style={{
            background: 'radial-gradient(circle at center, rgba(16, 185, 129, 0.4) 0%, rgba(16, 185, 129, 0) 70%)',
            transform: 'translate(30%, -30%)'
          }}
        ></div>

        <div
          className="absolute bottom-0 left-0 w-96 h-96 blur-3xl opacity-10"
          style={{
            background: 'radial-gradient(circle at center, rgba(59, 130, 246, 0.5) 0%, rgba(59, 130, 246, 0) 70%)',
            transform: 'translate(-30%, 30%)'
          }}
        ></div>

        <div 
          className="absolute inset-0 opacity-[0.02]" 
          style={{
            backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 76%, transparent 77%, transparent)',
            backgroundSize: '80px 80px'
          }}
        />
      </div>
      
      
      {/* Navbar */}
      <header className="sticky top-0 z-50">
        <NavBar />
      </header>
      
      <main>
        {/* Regular page sections in standard flow */}
        <section className="h-[100vh] flex items-center bg-white">
          <div className="w-full">
            <TitleSection />
          </div>
        </section>
        
        <section className="h-[100vh] flex items-center bg-transparent pt-24 w-full">
          <HeroSection />
        </section>
        
        <section className="h-[100vh] flex items-center bg-transparent pt-24">
          <div className="w-full">
            <FeaturedProcesses />
          </div>
        </section>
      </main>
      
      {/* Footer */}
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Index;
